<sh-footer-platform *ngIf="(isPlatform$ | async) === true && (canShowFooter$ | async) === true"></sh-footer-platform>
<sh-footer-business *ngIf="(isPlatform$ | async) === false && (canShowFooter$ | async) === true"></sh-footer-business>
